const e = {
  successWeak: "successWeak",
  successDefault: "successDefault",
  successStrong: "successStrong",
  infoWeak: "infoWeak",
  infoDefault: "infoDefault",
  infoStrong: "infoStrong",
  warningWeak: "warningWeak",
  warningDefault: "warningDefault",
  warningStrong: "warningStrong",
  errorWeak: "errorWeak",
  errorDefault: "errorDefault",
  errorStrong: "errorStrong",
  bgWeak: "bgWeak",
  bgDefault: "bgDefault",
  bgStrong: "bgStrong"
}, n = {
  contained: "contained",
  outlined: "outlined",
  text: "text",
  link: "link"
};
export {
  e as BADGE_COLOR,
  n as COLOR_VARIANT
};
//# sourceMappingURL=colorVariant.es.js.map
